// Utility function to count visible (non-hidden) comments
export const getVisibleCommentCount = (comments) => {
  if (!comments) return 0;
  
  return Object.values(comments).filter(comment => !comment.hidden).length;
};

// Utility function to get comment count text
export const getCommentCountText = (comments) => {
  const count = getVisibleCommentCount(comments);
  return count.toString();
}; 